import { getCardInstance, getLandDefinitionForInstance } from "../selectors/card-instances";
import type { FoundLandAction, GameEvent, SetupGameState } from "../types";
import type { TransitionResult } from "./advance-phase";
import { recordKingdomFoundation } from "./territory";

function eventId(actionSequence: number, ordinal: number): string {
  return `event-${actionSequence}-${ordinal}`;
}

export function applyFoundLand(
  state: Readonly<SetupGameState>,
  action: FoundLandAction,
  actionSequence: number,
): TransitionResult {
  const instance = getCardInstance(state, action.cardInstanceId);
  const definition = getLandDefinitionForInstance(state, action.cardInstanceId);
  if (instance === undefined || definition === undefined) {
    throw new Error("Validated Found Land action is missing its card definition.");
  }

  const maximumControl = definition.stages[0].maximumControl;
  const lane = state.lanes[action.laneId];
  const side = lane.players[action.playerId];
  const events: GameEvent[] = [
    {
      type: "land-founded",
      eventId: eventId(actionSequence, 0),
      actionSequence,
      playerId: action.playerId,
      laneId: action.laneId,
      cardInstanceId: action.cardInstanceId,
      cardDefinitionId: instance.cardDefinitionId,
      stage: 1,
      currentControl: maximumControl,
      maximumControl,
    },
    {
      type: "land-action-used",
      eventId: eventId(actionSequence, 1),
      actionSequence,
      playerId: action.playerId,
      actionType: "found-land",
      landActionsUsed: 1,
    },
  ];

  const foundedState: SetupGameState = {
    ...state,
    players: {
      ...state.players,
      [action.playerId]: {
        ...state.players[action.playerId],
        hand: state.players[action.playerId].hand.filter(
          (cardInstanceId) => cardInstanceId !== action.cardInstanceId,
        ),
        actionsUsed: {
          ...state.players[action.playerId].actionsUsed,
          landActions: 1,
        },
      },
    },
    lanes: {
      ...state.lanes,
      [action.laneId]: {
        ...lane,
        players: {
          ...lane.players,
          [action.playerId]: {
            ...side,
            status: "active",
            land: {
              cardInstanceIds: [action.cardInstanceId],
              stage: 1,
              currentControl: maximumControl,
              maximumControl,
              attackBonus: 0,
              guardBonus: 0,
            },
          },
        },
      },
    },
  };
  const kingdom = recordKingdomFoundation(
    foundedState,
    action.playerId,
    action.laneId,
    actionSequence,
    events.length,
  );
  return {
    state: kingdom.state,
    events: [...events, ...kingdom.events],
  };
}
